module.exports = __webpack_public_path__ + "assets/macbookPreview-1x.80461f0a70d14c4b42d0e1abb36e4bf6b65a6e9a43ffcb29957fd7518784360c.png";